import { Type } from '@angular/core';
import { TemplatesContainerComponent } from './templates-container/templates-container.component';

export const MODALS: {[name: string]: Type<any>} = {
    templatesContainerComponent: TemplatesContainerComponent,
  };